exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__payment-card-back___3xCER{position:relative;display:flex;flex-flow:column;width:100%;height:100%}.styles__payment-card-back___3xCER .styles__magnetic-stripe___3uj4P{width:100%;height:3rem;margin-top:1rem;background:#2c3e50}.styles__payment-card-back___3xCER .styles__signature-field___2fZfx{display:flex;align-items:flex-end;flex-flow:row;justify-content:flex-end;height:2rem;margin-top:.5rem;margin-right:6rem;margin-left:.5rem;background-image:repeating-linear-gradient(180deg,#f1c40f,#f1c40f 3px,#ecf0f1 0,#ecf0f1 6px)}.styles__payment-card-back___3xCER .styles__cvv___2CDkw{color:#2c3e50;font-family:OCR A Std}", ""]);

// exports
exports.locals = {
	"payment-card-back": "styles__payment-card-back___3xCER",
	"magnetic-stripe": "styles__magnetic-stripe___3uj4P",
	"signature-field": "styles__signature-field___2fZfx",
	"cvv": "styles__cvv___2CDkw"
};